import '../assets/css/bubbles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDatabase, faCode, faServer, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import { faNode, faNodeJs, faJava, faReact, faHtml5, faCss3Alt, faGithub, faGit, faAws, faBootstrap, faPython } from '@fortawesome/free-brands-svg-icons';

const Bubbles = () => {
    const bubble1 = { '--j': 11 };
    const bubble2 = { '--j': 5 };
    const bubble3 = { '--j': 6 };
    const bubble4 = { '--j': 10 };
    const bubble5 = { '--j': 14 };
    const bubble6 = { '--j': 23 };
    const bubble7 = { '--j': 18 };
    const bubble8 = { '--j': 16 };
    const bubble9 = { '--j': 19 };
    const bubble10 = { '--j': 20 };
    const bubble11 = { '--j': 22 };
    const bubble12 = { '--j': 25 };
    const bubble13 = { '--j': 18 };
    const bubble14 = { '--j': 15 };
    const bubble15 = { '--j': 13 };
    const bubble16 = { '--j': 26 };
    const bubble17 = { '--j': 17 };
    const bubble18 = { '--j': 13 };
    const bubble19 = { '--j': 28 };
    const bubble20 = { '--j': 9 };


    return (
        <div className="bubbles_container">

            <div className="bubbles">
                <span style={bubble1}><FontAwesomeIcon icon={faNode} /></span>
                <span style={bubble2}><FontAwesomeIcon className="icon-center" icon={faNodeJs} /></span>
                <span style={bubble3}><FontAwesomeIcon className="icon-center" icon={faReact} /></span>
                <span style={bubble4}><FontAwesomeIcon icon={faAws} /></span>
                <span style={bubble5}><FontAwesomeIcon className="icon-center" icon={faDatabase} /></span>
                <span style={bubble6}><FontAwesomeIcon className="icon-center" icon={faServer} /></span>
                <span style={bubble7}><FontAwesomeIcon icon={faCodeBranch} /></span>
                <span style={bubble8}><FontAwesomeIcon icon={faHtml5} /></span>
                <span style={bubble9}><FontAwesomeIcon className="icon-center" icon={faCss3Alt} /></span>
                <span style={bubble10}><FontAwesomeIcon className="icon-center" icon={faGithub} /></span>
                <span style={bubble11}><FontAwesomeIcon className="icon-center" icon={faBootstrap} /></span>
                <span style={bubble12}><FontAwesomeIcon className="icon-center" icon={faJava} /></span>
                <span style={bubble13}><FontAwesomeIcon className="icon-center" icon={faGit} /></span>
                <span style={bubble14}><FontAwesomeIcon className="icon-center" icon={faPython} /></span>
                <span style={bubble15}><FontAwesomeIcon className="icon-center" icon={faCode} /></span>
                <span style={bubble16}><span className="mysql" >MySQL</span></span>
                <span style={bubble17}><span className="api">API</span></span>
                <span style={bubble18}><span className="graphql">Graph QL</span></span>
                <span style={bubble19}><FontAwesomeIcon className="icon-center" icon={faNodeJs} /></span>
                <span style={bubble20}><FontAwesomeIcon className="icon-center" icon={faReact} /></span>

                <span style={bubble1}><FontAwesomeIcon icon={faNode} /></span>
                <span style={bubble2}><FontAwesomeIcon className="icon-center" icon={faNodeJs} /></span>
                <span style={bubble3}><FontAwesomeIcon className="icon-center" icon={faReact} /></span>
                <span style={bubble4}><FontAwesomeIcon icon={faAws} /></span>
                <span style={bubble5}><FontAwesomeIcon className="icon-center" icon={faDatabase} /></span>
                <span style={bubble6}><FontAwesomeIcon className="icon-center" icon={faServer} /></span>
                <span style={bubble7}><FontAwesomeIcon icon={faCodeBranch} /></span>
                <span style={bubble8}><FontAwesomeIcon icon={faHtml5} /></span>
                <span style={bubble9}><FontAwesomeIcon className="icon-center" icon={faCss3Alt} /></span>
                <span style={bubble10}><FontAwesomeIcon className="icon-center" icon={faGithub} /></span>
                <span style={bubble11}><FontAwesomeIcon className="icon-center" icon={faBootstrap} /></span>
                <span style={bubble12}><FontAwesomeIcon className="icon-center" icon={faJava} /></span>
                <span style={bubble13}><FontAwesomeIcon className="icon-center" icon={faGit} /></span>
                <span style={bubble14}><FontAwesomeIcon className="icon-center" icon={faPython} /></span>
                <span style={bubble15}><FontAwesomeIcon className="icon-center" icon={faCode} /></span>
                <span style={bubble16}><span className="mysql" >MySQL</span></span>
                <span style={bubble17}><span className="api">API</span></span>
                <span style={bubble18}><span className="graphql">Graph QL</span></span>
                <span style={bubble19}><FontAwesomeIcon className="icon-center" icon={faNodeJs} /></span>
                <span style={bubble20}><FontAwesomeIcon className="icon-center" icon={faReact} /></span>


            </div>
        </div>
    );
}

export default Bubbles;
